import React from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import moment from 'moment';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface HistoricoProps {

}

export default function Historico({ ...props }: HistoricoProps) {
  const [start, setStart] = React.useState<Date>(moment().startOf('month').toDate());
  const [end, setEnd] = React.useState<Date>(moment().endOf('month').toDate());

  const onDownload = () => {
    let link = `https://ribasdigital.cidadeinteligente.app.br/api/ouvidoria/relatorio/historico`;
    let token = localStorage.getItem('token');
    fetch(
      `${link}?start=${moment(start).format('YYYY-MM-DD')}&end=${moment(end).format('YYYY-MM-DD')}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then(r => r.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `historico-${moment(start).format('YYYY-MM-DD')}-${moment(end).format('YYYY-MM-DD')}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }
  //@ts-ignore
  return <PageContainer>
    <Paper>
      <Box p={2}>
        <Typography variant="h4" component="h1" gutterBottom> Histórco de Ocorrências </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={5}>
            <KeyboardDatePicker
              label="Data Inicial"
              value={start}
              onChange={(date) => setStart(date ? date.toDate() : new Date())}
              format="DD/MM/yyyy"
              variant="inline"
              inputVariant="outlined"
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <KeyboardDatePicker
              label="Data Final"
              value={end}
              onChange={(date) => setEnd(date ? date.toDate() : new Date())}
              format="DD/MM/yyyy"
              variant="inline"
              inputVariant="outlined"
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button variant="contained" color="primary" fullWidth onClick={onDownload}>
              Baixar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  </PageContainer>
}